export default __webpack_public_path__ + "static/media/simone_evaristo.27819325.jpeg";